import { useEffect, useState } from 'react';

export const useMediaDevices = () => {
	const [audioInputs, setAudioInputs] = useState<MediaDeviceInfo[]>([]);
	const [audioOutputs, setAudioOutputs] = useState<MediaDeviceInfo[]>([]);
	const [videoInputs, setVideoInputs] = useState<MediaDeviceInfo[]>([]);

	const loadDevices = async () => {
		try {
			// 1. Запрашиваем любой поток, чтобы получить ярлыки устройств
			const stream = await navigator.mediaDevices.getUserMedia({
				audio: true,
				video: true,
			});

			// 2. Сразу гасим камеру/микрофон
			stream.getTracks().forEach((t) => t.stop());

			// 3. Считываем список девайсов
			const devices = await navigator.mediaDevices.enumerateDevices();

			setAudioInputs(devices.filter((d) => d.kind === 'audioinput'));
			setAudioOutputs(devices.filter((d) => d.kind === 'audiooutput'));
			setVideoInputs(devices.filter((d) => d.kind === 'videoinput'));
		} catch (error) {
			console.error('Не удалось получить устройства:', error);
		}
	};

	useEffect(() => {
		loadDevices();
		navigator.mediaDevices.addEventListener('devicechange', loadDevices);
		return () => {
			navigator.mediaDevices.removeEventListener('devicechange', loadDevices);
		};
	}, []);

	return {
		audioInputs,
		audioOutputs,
		videoInputs,
		loadDevices,
	};
};
